import React, { Fragment } from 'react';
import { Intro, Video } from 'dea-core';
// import video from '../../assets/videos/DEA_OPW_M01_06.mp4';
import transcript from '../../assets/videos/DEA_OPW_M01_06.vtt';
// import poster from '../../assets/videos/';

const videoFiles = {
  sources: [
    {
      src:
        'https://operationprevention.com/sites/default/files/SPM_videos/module_1/DEA_OPW_M01_06.mp4'
    }
  ],
  tracks: [
    {
      src: transcript,
      kind: 'captions',
      label: 'English'
    }
  ],
  poster: ''
};

export default {
  title: 'Jason on Stealing Opioids',
  path: '/elaborate/jason',
  content: (
    <Fragment>
      <Intro
        title="Jason on stealing and selling prescription opioids as an addict."
        direction={'Select the play button below to begin.'}
        lead="One of the ways Jason obtained opioids was stealing from a family member recovering from a bad car accident."
      />
      <Video videoFiles={videoFiles} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/elaborate/Jason.js